<template>
  <div class="form-group theme-payment-page-form-item">
    <i class="fa fa-angle-down"></i>
    <select
      :id="`input-field-${_uid}`"
      :name="name"
      v-model="modelField"
      v-validate="required ? validate : ''"
      @change="$emit('update:field', $event.target.value)"
      :class="{ 'alert-danger': submitted && errors.has(name) }"
      class="form-control">
      <option value="">Mês</option>
      <option value="1">01</option>
      <option value="2">02</option>
      <option value="3">03</option>
      <option value="4">04</option>
      <option value="5">05</option>
      <option value="6">06</option>
      <option value="7">07</option>
      <option value="8">08</option>
      <option value="9">09</option>
      <option value="10">10</option>
      <option value="11">11</option>
      <option value="12">12</option>
    </select>
    <span class="theme-form-error-message">{{ errors.first(name) }}</span>
  </div>
</template>

<script>
export default {
  inject: [ '$validator' ],
  props: [
    'name',
    'submitted',
    'required',
    'validate',
    'field',
    'label'
  ],
  data () {
    return {
      modelField: '',
      modelValidate: ''
    }
  },
  watch: {
    field (data) {
      this.modelField = data
    }
  }
}
</script>
